import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const CheckIcon = (p: IconProps) => <Icon {...p}><path d="M20 6 9 17l-5-5" /></Icon>
